{
  "actions": {
    "addToCart": "In den Warenkorb",
    "close": "Schließen",
    "nextStep": "Nächster Schritt",
    "savingDesign": "Entwurf wird gespeichert...",
    "posterAdded": "Poster hinzugefügt",
    "retry": "Erneut versuchen"
  },
  "shipping": {
    "beforeNoon": "Vor 12:00 Uhr bestellt, heute versendet",
    "tomorrow": "Heute bestellt, morgen versendet",
    "onDate": "Heute bestellt, Versand am {date}"
  },
  "components": {
    "fontOptions": {
      "title": "Schriftart",
      "modern": "Modern",
      "classic": "Klassisch",
      "mono": "Mono"
    },
    "mapStyleSelector": {
      "modern": "Modern",
      "black": "Schwarz",
      "ocean": "Ozean",
      "sketch": "Skizze",
      "beige": "Beige",
      "color": "Farbe",
      "chic": "Chic",
      "gray": "Grau",
      "delft": "Delft"
    },
    "kaderSelector": {
      "title": "Rahmen auswählen",
      "none": "Keiner",
      "classic": "Klassisch",
      "heart": "Herz",
      "circle": "Kreis",
      "delft": "Delft"
    },
    "orientationSelector": {
      "title": "Ausrichtung auswählen",
      "portrait": "Hochformat",
      "landscape": "Querformat"
    },
    "materialToggle": {
      "title": "Produkt und Format",
      "paper": "Premium-Poster",
      "paperAlt": "Papierdruck",
      "acryl": "Acrylglasdruck",
      "aluminium": "Aluminiumdruck",
      "tile": "Handgefertigte Keramikfliese",
      "from": "Ab",
      "changeMaterial": "Anderes Material auswählen"
    },
    "productOptions": {
      "chooseSize": "Format auswählen",
      "inCentimeters": "in Zentimetern",
      "mostPopular": "Beliebt",
      "black": "Schwarz",
      "oak": "Eiche"
    },
    "paperOptions": {
      "chooseFrame": "Rahmen auswählen",
      "frameHelp": "Unsere FSC®-zertifizierten Posterrahmen bestehen aus massivem Hartholz (kein MDF) und sind mit entspiegeltem Acrylglas ausgestattet.",
      "noFrame": "Ohne Rahmen (selbst einrahmen)",
      "frameInfo": "Ein guter Rahmen macht den Unterschied. Gib deinem Poster die Wirkung, die es verdient."
    },
    "acrylOptions": {
      "transparencyInfo": "Alle weißen Bereiche im Entwurf werden transparent.",
      "chooseStand": "Standfuß auswählen",
      "noStand": "Ohne Standfuß (frei aufstellen)"
    },
    "aluminiumOptions": {
      "chooseColor": "Aluminiumfarbe auswählen",
      "silver": "Silber",
      "gold": "Gold",
      "bronze": "Bronze",
      "rose": "Rosé",
      "transparencyInfo": "Alle weißen Bereiche im Entwurf werden transparent und erhalten die Farbe des Aluminiums.",
      "chooseMount": "Aufhängung oder Standfuß auswählen",
      "hanger": "Aufhängung",
      "noMount": "Ohne Aufhängung oder Standfuß"
    },
    "tileOptions": {
      "chooseAccessory": "Zubehör auswählen",
      "blackFrame": "Schwarzer Rahmen",
      "oakFrame": "Eichenrahmen",
      "blackStand": "Schwarzer Halter",
      "oakStand": "Eichenhalter",
      "noAccessory": "Ohne Zubehör"
    },
    "giftOptions": {
      "giftwrapLabel": "Geschenkverpackung",
      "withoutGiftwrap": "Ohne Geschenkverpackung",
      "withGiftwrap": "Mit Geschenkverpackung + {price}",
      "giftcardLabel": "Geschenkkarte",
      "withoutCard": "Ohne Karte",
      "withCard": "Mit Karte + {price}",
      "messagePlaceholder": "Gib hier deine persönliche Nachricht ein..."
    },
    "shoppingBag": {
      "printTypes": {
        "paper": "Premium-Poster",
        "acryl": "Acrylglasdruck",
        "aluminium": "Aluminiumdruck",
        "tile": "Handgefertigte Keramikfliese"
      },
      "frames": {
        "black": "Schwarzer Rahmen",
        "oak": "Eichenrahmen",
        "white": "Weißer Rahmen"
      }
    },
    "trustpilot": {
      "reviewUrl": "https://de.trustpilot.com/review/wallable.nl?utm_medium=Trustbox&utm_source=EmailSignature2",
      "ratingImageUrl": "https://emailsignature.trustpilot.com/signature/de-DE/2/625eee8d230116b4f2ab2f13/text.png",
      "starsImageUrl": "https://emailsignature.trustpilot.com/signature/de-DE/2/625eee8d230116b4f2ab2f13/stars.png",
      "ratingAlt": "Trustpilot-Bewertung",
      "starsAlt": "Trustpilot-Sterne",
      "logoAlt": "Trustpilot-Logo"
    },
    "markerOptions": {
      "reorder": "Zum Sortieren ziehen oder die Pfeiltasten verwenden. Die oberste Markierung liegt vorne.",
      "location": "Standort",
      "size": "Größe",
      "centerPin": "Markierungen zentrieren",
      "removeConfirmation": "Möchtest du diese Markierung wirklich entfernen?",
      "confirmRemove": "Ja, entfernen",
      "cancelRemove": "Nein, abbrechen",
      "chooseIcon": "Symbol und Farbe für die Markierung auswählen:",
      "color": "Farbe der Markierung",
      "pinSize": "Größe der Markierung:",
      "searchPlaceholder": "Adresse, Stadt oder Ort suchen…"
    },
    "zoomToast": {
      "title": "Zoomen & Verschieben",
      "description": "Du kannst die Karte mit der Maus oder den Fingern verschieben sowie vergrößern und verkleinern."
    }
  },
  "errors": {
    "generic": "Es ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    "routeUnavailable": "Die Route konnte nicht geladen werden. Du kannst weiter gestalten oder eine andere Route auswählen.",
    "routesUnavailable": "Die Routen konnten nicht geladen werden. Lade die Seite neu und versuche es erneut oder kontaktiere uns."
  },
  "cityMap": {
    "productUrl": "https://wallable.de/product/stadtkarte/",
    "defaults": {
      "city": "Berlin",
      "region": "Berlin, Deutschland"
    },
    "common": {
      "addImagePin": "Markierung hinzufügen (mit Foto)",
      "textTitle": "Text auf deinem Entwurf",
      "text": "Text",
      "showCoordinates": "Koordinaten anzeigen",
      "map": "Karte",
      "loading": "Entwurf wird geladen..."
    },
    "meta": {
      "title": "Stadtplan-Poster gestalten",
      "description": "Gestalte ein persönliches Stadtplan-Poster von deinem besonderen Ort.",
      "ogTitle": "Persönliches Stadtplan-Poster - Wallable"
    },
    "fields": {
      "coordinates": "Koordinaten",
      "location": "Ortsname",
      "subtitle": "Bundesland, Land",
      "subtitle2": "Zusätzlicher Text (z. B. Namen)",
      "subtitle3": "Zusätzlicher Text (z. B. Umzugsdatum)"
    }
  },
  "housewarming": {
    "productUrl": "https://wallable.de/product/einweihungsposter/",
    "meta": {
      "title": "Gestalte dein eigenes Einweihungsposter!",
      "description": "Gestalte ein persönliches Einweihungsposter von einem besonderen Zuhause und Ort.",
      "ogTitle": "Persönliches Einweihungsposter - Wallable"
    },
    "fields": {
      "coordinates": "Koordinaten",
      "location": "Ortsname",
      "subtitle": "Bundesland, Land",
      "subtitle2": "Zusätzlicher Text (z. B. Umzugsdatum)",
      "subtitle3": "Zusätzlicher Text (überreicht von ...)"
    }
  },
  "realtor": {
    "productUrl": "https://wallable.de/product/relatiegeschenk-makelaar/",
    "meta": {
      "title": "Makler-Poster gestalten",
      "description": "Gestalte ein persönliches Hausposter als einzigartiges Geschenk vom Makler.",
      "ogTitle": "Persönliches Makler-Poster - Wallable"
    },
    "fields": {
      "coordinates": "Koordinaten",
      "location": "Ortsname",
      "subtitle": "Bundesland, Land",
      "subtitle2": "Zusätzlicher Text (z. B. Umzugsdatum)",
      "subtitle3": "Überreicht von ..."
    },
    "product": {
      "title": "Format und Rahmen",
      "framedPoster": "Gerahmtes Poster"
    }
  },
  "specialLocation": {
    "productUrl": "https://wallable.de/",
    "chooseEvent": "Ereignis auswählen",
    "meta": {
      "title": "Gestalte dein Poster von einem besonderen Ort!",
      "description": "Gestalte ein persönliches Poster von einem besonderen Ort und Ereignis.",
      "ogTitle": "Poster von einem besonderen Ort - Wallable"
    },
    "fields": {
      "coordinates": "Koordinaten",
      "location": "Ereignis",
      "subtitle": "Ort",
      "subtitle2": "Datum",
      "subtitle3": "Zusätzlicher Text"
    }
  },
  "hyrox": {
    "productUrl": "https://wallable.de/",
    "meta": {
      "title": "HYROX-Print konfigurieren",
      "description": "Gestalte einen persönlichen HYROX-Print deiner Leistung.",
      "ogTitle": "Gestalte deinen eigenen HYROX-Print - Wallable"
    },
    "event": {
      "title": "Event auswählen",
      "description": "Hier findest du eine Liste der uns bekannten Events. Klicke auf ein Event, um dessen Daten zu laden.",
      "search": "HYROX-Event suchen...",
      "searchAction": "HYROX-Event suchen",
      "division": "Division auswählen",
      "ageGroup": "Altersgruppe auswählen",
      "noResults": "Leider konnten wir nichts finden. Versuche einen anderen Suchbegriff oder kontaktiere uns."
    },
    "photo": {
      "choose": "Foto auswählen",
      "help": "Öffne ein Foto und wähle den gewünschten Ausschnitt.",
      "open": "Foto öffnen",
      "save": "Speichern",
      "poorQuality": "Mäßige Bildqualität",
      "qualityAdvice": "Wir empfehlen, ein Bild mit einer höheren Auflösung hinzuzufügen.",
      "edit": "Foto bearbeiten"
    },
    "editor": {
      "title": "Print personalisieren",
      "subtitle": "Klicken Sie auf die Schaltfläche unten, um eine HYROX-Veranstaltung zu suchen und die Daten zu laden.",
      "location": "Ort",
      "abbreviation": "Abkürzung",
      "participant": "Name des Teilnehmers",
      "finishTime": "Zielzeit",
      "date": "Datum",
      "division": "Division",
      "ageGroup": "Altersgruppe",
      "defaultName": "Dein Name",
      "defaultAgeGroup": "30–34 Jahre",
      "defaultFinishTime": "Deine Zeit"
    },
    "shopTitle": "Dein HYROX-Print",
    "actions": { "savingImage": "Bild wird gespeichert..." },
    "errors": {
      "photoSaveFailed": "Das Foto konnte nicht gespeichert werden. Kontaktiere uns über den Chat, damit wir dir helfen können.",
      "previewSaveFailed": "Die Vorschau konnte nicht gespeichert werden. Bitte versuche es erneut."
    }
  },
  "lovemap": {
    "productUrl": "https://wallable.de/product/liebeskarte/",
    "meta": {
      "title": "Liebeskarte gestalten ❤️",
      "description": "Gestalte eine persönliche Liebeskarte eurer besonderen Orte.",
      "ogTitle": "Gestalte dein eigenes Liebeskarten-Poster - Wallable"
    },
    "map": {
      "title": "Orte für dein Poster auswählen",
      "layout": "Layout auswählen",
      "blackWhiteHeart": "Schwarz-weißes Herz (2 Orte)",
      "blackHeart": "Schwarzes Herz (1 Ort)",
      "whiteHeart": "Weißes Herz (1 Ort)",
      "left": "Ort links (schwarz)",
      "right": "Ort rechts (weiß)",
      "location": "Ort",
      "nightLeft": "Ort links (Nacht)",
      "help": "Du kannst die Karte(n) mit der Maus oder den Fingern verschieben und zoomen."
    },
    "editor": {
      "title": "Poster personalisieren",
      "text": "Text",
      "names": "Name & Name",
      "location": "Ort",
      "date": "Datum",
      "color": "Farbe auswählen",
      "font": "Schriftart auswählen",
      "help": "Du kannst Textzeilen leer lassen oder den Text in eine andere Zeile verschieben. Emojis werden nicht unterstützt."
    },
    "product": {
      "title": "Format und Extras",
      "size": "Format auswählen",
      "frame": "Rahmen auswählen",
      "bestseller": "Bestseller",
      "noFrame": "Ohne Rahmen",
      "blackFrame": "Schwarzer Rahmen (Hartholz)",
      "oakFrame": "Naturrahmen (Eiche)"
    },
    "defaults": {
      "names": "Name & Name",
      "location": "Ort",
      "date": "Datum"
    },
    "concept": {
      "line1": "Das oben abgebildete Poster ist gleichzeitig dein Entwurf.",
      "line2": "Du erhältst es genau so, wie du es siehst."
    },
    "errors": {
      "previewFailed": "Die Vorschau konnte nicht gespeichert werden. Bitte versuche es erneut."
    }
  },
  "mothersDay": {
    "productUrl": "https://wallable.de/product/moederdag-city-map-poster-2/",
    "meta": {
      "title": "Gestalte dein Muttertagsposter!",
      "description": "Gestalte ein persönliches Muttertagsposter mit einem besonderen Ort.",
      "ogTitle": "Persönliches Muttertagsposter - Wallable"
    },
    "editor": {
      "title": "Eigenes Poster gestalten",
      "personalize": "Poster personalisieren",
      "pin": "Standortmarkierung",
      "withoutPin": "Ohne Standortmarkierung",
      "pinColor": "Farbe der Markierung",
      "dragPin": "Markierung selbst verschieben",
      "style": "Stil auswählen",
      "text": "Text",
      "coordinates": "Koordinaten",
      "headline": "Titel",
      "location": "Ort",
      "extra": "Zusätzlicher Text (optional)",
      "font": "Schriftart",
      "heartColor": "Farbe des Herzens",
      "circleColor": "Farbe des Kreises"
    },
    "product": {
      "title": "Format und Extras",
      "size": "Format",
      "frame": "Rahmen",
      "bestseller": "Bestseller"
    }
  },
  "fathersDay": {
    "productUrl": "https://wallable.de/product/vaderdag-city-map-poster/",
    "meta": {
      "title": "Gestalte dein Vatertagsposter!",
      "description": "Gestalte ein persönliches Vatertagsposter mit einem besonderen Ort und Foto.",
      "ogTitle": "Persönliches Vatertagsposter - Wallable"
    },
    "photo": {
      "choose": "Foto auswählen",
      "help": "Öffne ein Foto und wähle den Bereich aus, der in der Markierung erscheinen soll.",
      "inPin": "Foto in der Markierung",
      "poorQuality": "Schlechte Bildqualität"
    },
    "editor": {
      "locationTitle": "Ort auswählen",
      "personalize": "Entwurf personalisieren",
      "pin": "Standortmarkierung",
      "withPin": "Mit Standortmarkierung",
      "iconPin": "Markierung mit Symbol",
      "photoPin": "Markierung mit Foto",
      "pinColor": "Farbe der Markierung",
      "dragPin": "Markierung selbst verschieben",
      "style": "Stil",
      "orientation": "Ausrichtung",
      "portrait": "Hochformat",
      "landscape": "Querformat",
      "moustache": "Schnurrbart hinzufügen",
      "text": "Text",
      "coordinates": "Koordinaten",
      "headline": "Titel",
      "location": "Ort",
      "extra": "Zusätzlicher Text (optional)",
      "font": "Schriftart"
    },
    "actions": { "savingImage": "Bild wird gespeichert..." }
  },
  "psalm": {
    "productUrl": "https://wallable.de/",
    "meta": {
      "title": "Psalm-Poster konfigurieren 📖",
      "description": "Gestalte ein persönliches Poster mit einem Psalm.",
      "ogTitle": "Gestalte dein eigenes Psalm-Poster - Wallable"
    },
    "archive": {
      "title": "Psalm auswählen",
      "description": "Hier findest du eine Liste verfügbarer Psalmen. Klicke auf einen Psalm, um ihn zu laden, und passe den Text anschließend an.",
      "search": "Psalm suchen...",
      "choose": "Psalm aus unserem Archiv auswählen",
      "noResults": "Leider konnten wir nichts finden."
    },
    "editor": {
      "title": "Poster personalisieren",
      "text": "Text",
      "help": "Ändere unten den Text auf deinem Poster",
      "psalm": "Psalm",
      "description": "Text des Psalms...",
      "defaultReference": "Psalm 23:3",
      "defaultText": "Er erquicket meine Seele; er führet mich auf rechter Straße um seines Namens willen."
    }
  },
  "dictionary": {
    "productUrl": "https://wallable.de/product/woerterbuch-poster/",
    "meta": {
      "title": "Wörterbuch-Poster gestalten",
      "description": "Gestalte ein persönliches Wörterbuch-Poster mit deinem besonderen Wort.",
      "ogTitle": "Gestalte dein eigenes Wörterbuch-Poster - Wallable"
    },
    "archive": {
      "title": "Wort auswählen",
      "description": "Hier findest du eine Liste verfügbarer Wörter. Klicke auf ein Wort, um es zu laden, und passe den Text anschließend an.",
      "search": "Wort suchen...",
      "choose": "Wort aus unserem Archiv auswählen",
      "noResults": "Leider konnten wir nichts finden."
    },
    "editor": {
      "title": "Poster personalisieren",
      "text": "Text",
      "help": "Ändere unten den Text auf deinem Poster",
      "word": "Wort",
      "pronunciation": "Aussprache",
      "type": "Wortart",
      "description": "Beschreibung des Wortes...",
      "defaultWord": "Ihr Wort",
      "defaultPronunciation": "[Aussprache]",
      "defaultType": "Wortart",
      "defaultDescription": "Definition Ihres Wortes..."
    }
  },
  "photoGift": {
    "productUrl": "https://wallable.de/",
    "meta": {
      "title": "Dein Fotogeschenk",
      "description": "Gestalte ein einzigartiges Fotogeschenk mit deinem eigenen Foto, Stil und persönlichen Text.",
      "ogTitle": "Gestalte deinen eigenen Fotodruck - Wallable"
    },
    "photo": {
      "choose": "Foto auswählen",
      "cropHelp": "Öffne ein Foto und wähle den Bereich aus, den du sehen möchtest.",
      "open": "Foto öffnen",
      "save": "Speichern",
      "edit": "Foto bearbeiten",
      "chooseStyle": "Stil auswählen",
      "aiHelpBefore": "Unser digitaler Künstler lernt noch. Daher können manche Umwandlungen fehlschlagen. Nimm in diesem Fall",
      "contact": "Kontakt",
      "aiHelpAfter": "mit uns auf, damit wir dir helfen können.",
      "orientation": "Ausrichtung",
      "portrait": "Hochformat",
      "landscape": "Querformat"
    },
    "text": {
      "title": "Dein Text",
      "show": "Text zum Druck hinzufügen",
      "top": "Zusätzlicher Text oben",
      "headline": "Titel",
      "subtitle": "Untertitel",
      "bottom": "Zusätzlicher Text unten",
      "help": "Du kannst Felder leer lassen, wenn du sie nicht verwenden möchtest.",
      "defaultHeadline": "Dein Titel",
      "defaultSubtitle": "Dein Untertitel"
    },
    "transform": {
      "none": "Keine",
      "delft": "Delft",
      "watercolor": "Aquarell",
      "cartoon": "Cartoon",
      "charcoal": "Kohlezeichnung",
      "vintage": "Vintage",
      "starting": "Umwandlung wird gestartet",
      "progress1": "Dein Foto wird verwandelt... ✨",
      "progress2": "Wir erstellen jetzt die gewählte Stilversion deines Fotos 🎨",
      "progress3": "Unser digitaler Künstler malt gerade fleißig...",
      "progress4": "Nur noch ein paar Pinselstriche bis zum perfekten Ergebnis 🖌️",
      "progress5": "Fast fertig! Gute Kunst braucht manchmal etwas mehr Zeit."
    },
    "errors": {
      "transformFailed": "Die Fotoumwandlung ist fehlgeschlagen. Bitte versuche es erneut.",
      "photoSaveFailed": "Das Foto konnte nicht gespeichert werden. Kontaktiere uns über den Chat, damit wir dir helfen können.",
      "photoRequired": "Lade zuerst ein Foto hoch."
    },
    "actions": {
      "savingImage": "Bild wird gespeichert..."
    },
    "navigation": {
      "photo": "Foto",
      "text": "Text"
    }
  },
  "datePoster": {
    "productUrl": "https://wallable.de/product/besonderes-datum-poster/",
    "meta": {
      "title": "Gestalte dein eigenes Datumsposter 🗓️",
      "description": "Halte ein besonderes Datum mit einem persönlichen Datumsposter stilvoll fest.",
      "ogTitle": "Gestalte dein eigenes Poster für ein besonderes Datum - Wallable"
    },
    "editor": {
      "title": "Personalisiere dein Poster",
      "textTitle": "Text",
      "textHelp": "Ändere unten den Text auf deinem Poster",
      "day": "Tag",
      "month": "Monat",
      "year": "Jahr",
      "event": "Etwas Besonderes",
      "names": "Ben & Emma",
      "chooseColor": "Farbe auswählen"
    },
    "navigation": {
      "personalize": "Personalisieren"
    },
    "defaults": {
      "event": "Ereignis",
      "names": "Ben & Emma"
    }
  },
  "starmap": {
    "productUrl": "https://wallable.de/",
    "meta": {
      "title": "⭐️ Sternenkarte gestalten",
      "description": "Gestalte ein persönliches Sternenkarten-Poster von einem besonderen Moment.",
      "ogTitle": "Gestalte dein eigenes Sternenkarten-Poster - Wallable"
    },
    "editor": {
      "title": "Gestalte deine eigene Sternenkarte",
      "chooseDateTime": "Datum und Uhrzeit auswählen",
      "showTime": "Uhrzeit anzeigen",
      "noTimeHelp": "Wenn du keine Uhrzeit angibst, zeigen wir den Sternenhimmel um Mitternacht.",
      "chooseText": "Text auswählen"
    },
    "fields": {
      "coordinates": "Koordinaten",
      "moment": "Dein besonderer Moment",
      "dateTime": "Datum und Uhrzeit",
      "extraText": "Zusätzlicher Text (optional)"
    },
    "date": {
      "year": "Jahr",
      "month": "Monat",
      "day": "Tag"
    },
    "style": {
      "title": "Entwurf personalisieren",
      "chooseFont": "Schriftart auswählen",
      "chooseColor": "Farbe auswählen",
      "chooseBackground": "Hintergrundfarbe auswählen",
      "light": "Hell",
      "dark": "Dunkel",
      "chooseBorder": "Rahmen auswählen",
      "withBorder": "Mit Rahmen",
      "withoutBorder": "Ohne Rahmen",
      "customizeSky": "Sternenhimmel anpassen",
      "constellations": "Sternbilder",
      "milkyWay": "Milchstraße",
      "grid": "Raster"
    },
    "navigation": {
      "moment": "Moment",
      "style": "Stil"
    },
    "defaults": {
      "event": "Ereignis",
      "customMoment": "Andere Angabe (unten selbst schreiben)"
    },
    "moments": {
      "1": "Du & Ich",
      "2": "Erster Kuss",
      "3": "Als die Sterne richtig standen",
      "4": "Wo alles begann",
      "5": "Liebe unter den Sternen",
      "6": "Als wir geheiratet haben",
      "7": "In dieser Nacht wurde ein Stern geboren",
      "8": "Der Sternenhimmel bei deiner Geburt",
      "9": "Die Nacht, in der du zur Welt kamst",
      "10": "Als ich geboren wurde",
      "11": "Als der Funke übersprang",
      "12": "Der Moment, in dem wir Ja sagten",
      "13": "Unser Zuhause unter den Sternen",
      "14": "Als die Sterne richtig standen",
      "15": "Du & Ich",
      "16": "Wo es geschah",
      "17": "Wo alles begann",
      "18": "Erstes Date",
      "19": "Als wir uns kennenlernten",
      "20": "Als alles begann",
      "21": "Erster Kuss",
      "22": "Als sie Ja sagte",
      "23": "Als er Ja sagte",
      "24": "Als ich geboren wurde"
    }
  },
  "songtext": {
    "productUrl": "https://wallable.de/product/songtext-lyrics-poster/",
    "meta": {
      "title": "🎵 Songtext-Poster konfigurieren",
      "description": "Gestalte ein persönliches Poster mit dem Songtext deines Lieblingslieds.",
      "ogTitle": "Gestalte dein eigenes Songtext-Poster - Wallable"
    },
    "search": {
      "loading": "Songtext wird geladen",
      "loadingHelp": "Das kann einen Moment dauern. Bitte hab etwas Geduld :)",
      "title": "Songtext suchen",
      "description": "Verwende das Suchfeld, um nach einem Song zu suchen.",
      "placeholder": "Titel oder Künstlername",
      "action": "Suchen",
      "error": "Der Songtext konnte leider nicht geladen werden. Versuche es erneut oder kontaktiere uns.",
      "noResults": "Leider konnten wir nichts finden."
    },
    "editor": {
      "introduction": "Lade über die Schaltfläche einen Songtext aus unserer Datenbank oder gib deinen eigenen Text ein.",
      "title": "Text personalisieren",
      "songName": "Name des Songs",
      "artist": "Name des Künstlers",
      "extraText": "Zusätzlicher Text (optional)",
      "lyrics": "Ausschnitt aus dem Songtext...",
      "maxCharacters": "Maximale Zeichenanzahl erreicht.",
      "defaultArtist": "Künstler",
      "defaultSong": "Lieblingssong",
      "defaultLyrics": "Songtext deines Lieblingslieds. Verwende die Suche, um einen Songtext zu finden, oder gib deinen eigenen Text ein."
    },
    "style": {
      "image": "Bild",
      "icon": "Symbol",
      "cover": "Cover / Foto",
      "chooseIcon": "Symbol und Farbe auswählen:",
      "iconColor": "Farbe des Symbols",
      "color": "Farbe",
      "colorWarning": "Farben können nur für einen Druck auf Papier (Premium-Poster) ausgewählt werden"
    },
    "spotify": {
      "title": "Spotify-Code",
      "show": "Spotify-Code anzeigen",
      "placeholder": "Spotify-Link",
      "invalid": "Ungültiger Spotify-Link.",
      "tooltip": "Öffne die Spotify-App, gehe zu Suchen und scanne den Code auf dem Poster, um den Song direkt zu öffnen.",
      "help": "Den Spotify-Link eines Songs findest du in der Spotify-App über Teilen und Link kopieren. Füge ihn anschließend in das Feld oben ein."
    },
    "actions": {
      "copyUrl": "Poster-URL kopieren"
    },
    "navigation": {
      "lyrics": "Songtext",
      "style": "Stil"
    }
  },
  "corporateGift": {
    "productUrl": "https://wallable.de/product/stadtkarte-mit-firmenname-und-logo/",
    "loading": "Entwurf wird geladen...",
    "meta": {
      "title": "Gestalte dein persönliches Firmengeschenk als Stadtplan-Poster!",
      "description": "Verschenke ein persönliches Firmengeschenk mit einer einzigartigen Karte eines besonderen Unternehmensstandorts.",
      "ogTitle": "Persönliches Firmengeschenk als Stadtplan-Poster gestalten - Wallable"
    },
    "photo": {
      "title": "Foto auswählen",
      "description": "Öffne ein Foto und wähle den Bereich aus, der in der Markierung erscheinen soll.",
      "open": "Foto öffnen",
      "save": "Speichern"
    },
    "map": {
      "title": "Standort und Markierungen",
      "markerLabel": "Postermarkierung",
      "withoutPins": "Ohne Standortmarkierung(en)",
      "withPins": "Mit Standortmarkierung(en)",
      "yourPins": "Deine Standortmarkierung(en)",
      "dragPins": "Markierung(en) selbst verschieben",
      "dragPinsHelp": "Sitzt die Standortmarkierung noch nicht richtig? Entsperre die Markierungen und ziehe sie an die gewünschte Position.",
      "addPins": "Weitere Markierungen hinzufügen",
      "addIconPin": "Markierung hinzufügen (Symbol)",
      "addImagePin": "Markierung hinzufügen (Foto/Logo)"
    },
    "text": {
      "title": "Text auf deinem Entwurf",
      "coordinates": "Koordinaten",
      "showCoordinates": "Koordinaten anzeigen",
      "location": "Ortsname",
      "company": "Firmenname",
      "date": "Eröffnungs-/Umzugsdatum",
      "offeredBy": "Überreicht von ...",
      "help": "Du kannst Textzeilen leer lassen oder den Text in eine andere Zeile verschieben. Emojis werden nicht unterstützt."
    },
    "navigation": {
      "map": "Karte",
      "text": "Text"
    }
  },
  "sportsmap": {
    "productUrl": "https://wallable.de/product/sportkarte/",
    "defaultRouteName": "Sportroute",
    "genericRouteName": "Route",
    "loading": "Entwurf wird geladen...",
    "routeFile": "Die Routendatei",
    "meta": {
      "title": "Gestalte dein eigenes Sportposter 💪",
      "description": "Erwecke deine unvergessliche sportliche Leistung mit einem personalisierten Routenposter zum Leben.",
      "ogTitle": "Dein Sportposter - Einzigartig und personalisiert"
    },
    "gpx": {
      "title": "Wie erhalte ich eine GPX-Datei?",
      "introduction": "Eine GPX-Datei enthält die Strecke, die du gelaufen, gefahren oder gewandert bist. Wähle unten die App aus, in der deine Aktivität gespeichert ist, und folge den Schritten in Ruhe nacheinander.",
      "generalTip": "Du kannst alles direkt auf deinem Smartphone erledigen. Bei komoot funktioniert der Export direkt in der App. Für Strava, Runkeeper, Garmin Connect und Polar Flow verwendest du die Website in Safari oder Chrome.",
      "strava": {
        "label": "Von Strava",
        "notice": "In der Strava-App fehlt die Download-Schaltfläche. Führe diese Schritte in Safari oder Chrome auf deinem Smartphone aus.",
        "step1": "Öffne www.strava.com in Safari oder Chrome und melde dich an.",
        "step2": "Öffne die Desktop-Version der Website. Tippe auf dem iPhone in Safari links neben der Adressleiste auf die Taste für das Seitenmenü und danach auf „Desktop-Website anfordern“. Tippe in Chrome auf Android auf die drei Punkte und aktiviere „Desktopwebsite“.",
        "step3": "Öffne das Strava-Menü, wähle „Training“ und danach „Meine Aktivitäten“. Tippe auf die Aktivität, die du auf dem Poster zeigen möchtest.",
        "step4": "Tippe auf der Aktivitätsseite auf die drei Punkte (•••) und wähle „GPX exportieren“. Wähle Downloads oder Dateien aus, wenn dein Smartphone nach dem Speicherort fragt."
      },
      "komoot": {
        "label": "Von Komoot",
        "notice": "Diese Schritte kannst du direkt in der komoot-App ausführen.",
        "step1": "Öffne die komoot-App und tippe unten auf „Profil“.",
        "step2": "Öffne „Geplante Touren“ oder „Abgeschlossene Aktivitäten“ und tippe auf die Strecke, die du auf dem Poster zeigen möchtest.",
        "step3": "Tippe bei der Strecke auf „GPX-Datei herunterladen“.",
        "step4": "Auf Android wird die Datei normalerweise automatisch unter Downloads gespeichert. Auf dem iPhone wählst du „In Dateien sichern“ und danach „Downloads“ aus."
      },
      "runkeeper": {
        "label": "Von Runkeeper",
        "notice": "In der Runkeeper-App kannst du keine einzelnen GPX-Dateien herunterladen. Über Safari oder Chrome auf deinem Smartphone kannst du deine Aktivitäten trotzdem exportieren.",
        "step1": "Öffne www.runkeeper.com in Safari oder Chrome und melde dich an.",
        "step2": "Öffne die Desktop-Version der Website. Tippe auf dem iPhone in Safari links neben der Adressleiste auf die Taste für das Seitenmenü und danach auf „Desktop-Website anfordern“. Tippe in Chrome auf Android auf die drei Punkte und aktiviere „Desktopwebsite“.",
        "step3": "Tippe oben rechts auf das Zahnrad, wähle „Account Settings“ und danach „Export Data“.",
        "step4": "Wähle einen Start- und Endtermin, in dem deine Aktivität liegt, und tippe auf „Export Data“. Warte, bis „Download Now!“ erscheint, und tippe darauf. Öffne anschließend die heruntergeladene ZIP-Datei unter Downloads oder Dateien, um sie zu entpacken. Im neuen Ordner findest du die GPX-Dateien, die du bei Wallable hochladen kannst."
      },
      "garmin": {
        "label": "Von Garmin Connect",
        "notice": "In der Garmin-Connect-App gibt es keine GPX-Download-Schaltfläche. Verwende deshalb Safari oder Chrome auf deinem Smartphone.",
        "step1": "Öffne connect.garmin.com in Safari oder Chrome und melde dich mit deinem Garmin-Konto an.",
        "step2": "Öffne die Desktop-Version der Website. Tippe auf dem iPhone in Safari links neben der Adressleiste auf das Seitenmenü und danach auf „Desktop-Website anfordern“. Tippe in Chrome auf Android auf die drei Punkte und aktiviere „Desktopwebsite“.",
        "step3": "Öffne das Menü, wähle „Aktivitäten“ und danach „Alle Aktivitäten“. Tippe auf die Aktivität, die du auf dem Poster zeigen möchtest.",
        "step4": "Tippe oben rechts auf das Zahnrad und wähle „Als GPX exportieren“. Die Datei wird unter Downloads oder Dateien gespeichert."
      },
      "polar": {
        "label": "Von Polar Flow",
        "notice": "Verwende Safari oder Chrome auf deinem Smartphone. Der GPX-Export befindet sich auf der Polar-Flow-Website und nicht in der App.",
        "step1": "Öffne flow.polar.com in Safari oder Chrome und melde dich mit deinem Polar-Konto an.",
        "step2": "Öffne die Desktop-Version der Website. Tippe auf dem iPhone in Safari links neben der Adressleiste auf das Seitenmenü und danach auf „Desktop-Website anfordern“. Tippe in Chrome auf Android auf die drei Punkte und aktiviere „Desktopwebsite“.",
        "step3": "Öffne „Tagebuch“ und tippe auf die Trainingseinheit, die du auf dem Poster zeigen möchtest.",
        "step4": "Tippe oben rechts auf „Exportieren“ und wähle die GPX-Datei. Wähle nicht die ZIP-Version. Die GPX-Datei wird unter Downloads oder Dateien gespeichert."
      }
    },
    "actions": {
      "viewDesign": "Entwurf ansehen",
      "centerRoute": "Route zentrieren",
      "help": "Können wir helfen?"
    },
    "routesModal": {
      "title": "Route auswählen",
      "description": "Hier findest du eine Liste der uns bekannten Routen. Klicke auf eine Route, um sie zu laden.",
      "searchPlaceholder": "Nach einer Route oder Sportveranstaltung suchen...",
      "noResults": "Leider konnten wir nichts finden. Versuche einen anderen Suchbegriff oder kontaktiere uns, um eine Route hinzuzufügen."
    },
    "routeStep": {
      "title": "Route auswählen",
      "description": "Wähle eine vorhandene Route aus oder lade eine oder mehrere Routen aus deiner",
      "trackingApp": "Sport-Tracking-App",
      "chooseArchive": "Route aus unserem Archiv auswählen",
      "uploadOwn": "Eigene Route(n) hochladen",
      "yourRoutes": "Deine Route(n)",
      "labelsOverRoute": "Ortsnamen über der Route anzeigen",
      "unlockMap": "Karte entsperren",
      "unlockHelp": "Sitzt die Karte noch nicht richtig? Entsperre sie, um sie mit der Maus oder den Fingern zu zoomen und an die richtige Position zu verschieben."
    },
    "textStep": {
      "title": "Text auf deinem Entwurf",
      "dateDistancePlaceholder": "Datum / Distanz",
      "nameTimePlaceholder": "Name und Zeit"
    },
    "styleStep": {
      "title": "Kartenstil"
    },
    "routeOptions": {
      "settings": "Routeneinstellungen",
      "remove": "Route entfernen",
      "thickness": "Linienstärke der Route",
      "routeColor": "Farbe der Route",
      "startColor": "Farbe des Startpunkts",
      "endColor": "Farbe des Endpunkts",
      "showStart": "Startpunkt anzeigen",
      "showEnd": "Endpunkt anzeigen",
      "removeConfirmation": "Möchtest du diese Route wirklich entfernen?",
      "confirmRemove": "Ja, entfernen",
      "cancelRemove": "Nein, abbrechen"
    },
    "shop": {
      "deliveryNote": "Meist schon am nächsten Tag bei dir",
      "subtotal": "Zwischensumme:",
      "saving": "Entwurf wird gespeichert...",
      "added": "Poster hinzugefügt"
    },
    "errors": {
      "routeRequired": "Füge mindestens eine Route hinzu, bevor du den Entwurf speicherst.",
      "saveFailed": "Der Entwurf konnte nicht gespeichert werden. Bitte versuche es erneut.",
      "cartFailed": "Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
      "startupFailed": "Dein Entwurf konnte nicht vollständig geladen werden. Bitte versuche es erneut.",
      "routeFileFailed": "{name} konnte nicht geladen werden."
    },
    "navigation": {
      "routes": "Route",
      "personalize": "Personalisieren",
      "product": "Produkt",
      "order": "Bestellen"
    },
    "defaults": {
      "location": "Ort",
      "dateDistance": "Datum / 42,195 KM",
      "nameTime": "Dein Name & deine Zeit",
      "achievement": "Sportliche Leistung"
    }
  }
}
